import { List, Map as ImmutableMap } from 'immutable';
import uniqueId from 'transmute/uniqueId';
//@ts-expect-error Untyped import
import { pickColors } from 'reporting-ui-components/reports/utils/colors/colorPicker';
import { THEME, getStaticLegacyThemes } from 'reporting-ui-components/constants/themes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getColors = theme => {
  const reportingThemes = getStaticLegacyThemes('report-customization-components.ColorSwatch');
  const colorsTheme = theme === THEME.PATTERNS ? reportingThemes.getIn([theme, 'colorsTheme']) : theme;
  const colors = pickColors(ImmutableMap({
    theme: colorsTheme
  }), List([0, 1, 2])).toList();
  return colorsTheme === THEME.MULTI ? colors.toJS() : colors.reverse();
};
const ColorSwatch = ({
  size = 24,
  theme = THEME.MULTI
}) => {
  const [primaryColor, secondaryColor, tertiaryColor] = getColors(theme);
  if (theme === THEME.PATTERNS) {
    const paletteId = uniqueId('patterns-palette-');
    return /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      children: [/*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx("pattern", {
          id: paletteId,
          x: "0",
          y: "0",
          width: ".25",
          height: ".25",
          patternTransform: "rotate(45)",
          children: /*#__PURE__*/_jsx("line", {
            x1: "0",
            y: "0",
            x2: "0",
            y2: "11",
            stroke: primaryColor,
            strokeWidth: "5"
          })
        })
      }), /*#__PURE__*/_jsx("rect", {
        fill: `url(#${paletteId})`,
        stroke: "none",
        width: size,
        height: size
      })]
    });
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "1",
      y: "1",
      fill: primaryColor,
      width: "24",
      height: "48"
    }), /*#__PURE__*/_jsx("rect", {
      x: "25",
      y: "1",
      fill: secondaryColor,
      width: "24",
      height: "24"
    }), /*#__PURE__*/_jsx("rect", {
      x: "25",
      y: "25",
      fill: tertiaryColor,
      width: "24",
      height: "24"
    })]
  });
};
export default ColorSwatch;